module.exports = __webpack_public_path__ + "images/brand/portable-storage/packRatLogo.png";